import script from "./login_register.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_register.vue?vue&type=script&lang=ts&setup=true"

import "./login_register.vue?vue&type=style&index=0&id=3142a157&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3142a157"]])

export default __exports__